// extracted by mini-css-extract-plugin
module.exports = {"issue-info":"Request_issue-info__D-qqA","settlement":"Request_settlement__2gghi","settlement__boxes":"Request_settlement__boxes__36UB3","table":"Request_table__27N0L"};